/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Email/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromValidate from 'Data/validate.js'
import React from 'react'
import TysiaInput from 'DesignSystem/TysiaInput/index'
import TysiaInputContent from 'DesignSystem/TysiaInput/TysiaInputContent/index'
import TysiaInputField from 'DesignSystem/TysiaInput/TysiaInputField/index'
import TysiaInputLabel from 'DesignSystem/TysiaInput/TysiaInputLabel/index'



/** @type {import('Simple/types.js').View} */
export default function Email({
  children,
  viewPath = "/App/Auth/ResetPassword/Email",
  isInvalid,
  onChange,
  onSubmit
  
}) {
let resetPasswordEmailValueData = fromData.useDataValue({ viewPath,
context: 'reset_password',
path: 'email',
})
let resetPasswordEmailIsValidData = fromData.useDataIsValid({ viewPath,
context: 'reset_password',
path: 'email',
validate: fromValidate.email,
required: true,
})
let resetPasswordEmailChangeData = fromData.useDataChange({ viewPath,
context: 'reset_password',
path: 'email',
})
let resetPasswordEmailSubmitData = fromData.useDataSubmit({ viewPath,
context: 'reset_password',
})
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
  return (<React.Fragment
>
<TysiaInput
  viewPath={`${viewPath}/TysiaInput`}
 marginTop={dtSpaceXs}
 data="reset_password.email"
 validate="/Data/validate.js email"
 required={true}
 invalid={!resetPasswordEmailIsValidData}
 value={resetPasswordEmailValueData}
 onChange={resetPasswordEmailChangeData}
 onSubmit={resetPasswordEmailSubmitData}
>
{childProps => (
<React.Fragment>
<TysiaInputLabel
{...childProps}
  viewPath={`${viewPath}/TysiaInputLabel`}
 text="Email"
/>
<TysiaInputContent
{...childProps}
  viewPath={`${viewPath}/TysiaInputContent`}
>
{childProps => (
<TysiaInputField
{...childProps}
  viewPath={`${viewPath}/TysiaInputField`}
 type="email"
 autoFocus={true}
/>
)}
</TysiaInputContent>
</React.Fragment>
)}
</TysiaInput>
{children}
</React.Fragment>)
}